<script>
    export let name
    export let value
</script>
<div class="container">
    <slot></slot>
    <div>
        <p>{name}</p>
        <p>{value}</p>
    </div>
</div>
<style>

    .container {
        color: #000;
        padding: 2em;
        display: flex;
        justify-content: center;
    }

    p {
        color: var(--grey-color);
        margin: 3px 0 3px 18px;
    }

    p + p {
        color: #000;
        font-size: 1.3em;
        font-weight: 700;
    }

    :global(main.tiny) .container {
        flex-direction: column;
        padding: 1em;
    }

    :global(main.tiny) .container div {
        margin: 1em 0;
    }

    :global(main.tiny) .container p {
        text-align: center;
        margin: 3px;
    }
</style>